export const movies = [
  {
    id: "1",
    title: "星海彼岸",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20space%20poster%20art%2C%20lone%20astronaut%20silhouette%20before%20a%20glowing%20blue%20nebula%2C%20deep%20navy%20tones%20with%20orange%20light%20accents%2C%20dramatic%20atmosphere%2C%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-01&orientation=portrait",
    genres: ["科幻", "冒险", "剧情"],
    region: "中国",
    year: 2026,
    rating: 8.7,
    director: "陆云深",
    actors: ["周牧野", "林知夏", "程远"],
    duration: "142分钟",
    releaseDate: "2026-02-14",
    summary: "一支远征队在星海尽头发现未知信标，人类的命运悬于一次抉择。",
    synopsis: "遥远的未来，人类将最后的希望寄托于一次跨越星海的远征。队长陆行舟带领小队抵达被遗忘的深空站，却发现这里藏着关于文明起源的秘密。当通讯逐渐中断、队友接连陷入幻象，他们不得不在信任与生存之间做出选择。《星海彼岸》以宏大的宇宙景观包裹一段关于孤独与信念的故事。",
    featured: true,
    isHot: true,
  },
  {
    id: "2",
    title: "长夜将尽",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=dark%20mystery%20thriller%20poster%20art%2C%20rainy%20city%20street%20at%20night%20with%20a%20lone%20figure%20under%20a%20street%20lamp%2C%20moody%20navy%20and%20amber%20lighting%2C%20cinematic%20shadow%2C%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-02&orientation=portrait",
    genres: ["悬疑", "犯罪"],
    region: "中国",
    year: 2025,
    rating: 8.3,
    director: "苏慕白",
    actors: ["谢明川", "许南星", "罗诚"],
    duration: "124分钟",
    releaseDate: "2025-11-08",
    summary: "一桩尘封多年的旧案重启，真相在漫长的夜里逐渐浮出水面。",
    synopsis: "老刑警陈默即将退休，却被一桩十六年前的悬案重新拽回漩涡。随着调查深入，当年所有当事人都各怀秘密，看似无关的细节串成一条冰冷的链条。真相与代价、正义与私心交织，他必须在长夜结束之前找到答案。",
    featured: true,
    isHot: true,
  },
  {
    id: "3",
    title: "烟火人间",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=warm%20slice%20of%20life%20drama%20poster%20art%2C%20old%20town%20alley%20at%20dusk%20with%20warm%20lanterns%20and%20steaming%20food%20stalls%2C%20cozy%20amber%20and%20soft%20navy%20tones%2C%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-03&orientation=portrait",
    genres: ["剧情", "家庭"],
    region: "中国",
    year: 2024,
    rating: 8.9,
    director: "何知远",
    actors: ["王素芬", "赵大山", "李小满"],
    duration: "118分钟",
    releaseDate: "2024-09-20",
    summary: "一条老街、一家小饭馆，三代人的悲欢都盛在一碗热汤里。",
    synopsis: "老城改造在即，经营了三十年的“和记小馆”面临拆迁。老板娘王素芬坚持营业到最后一天，远走他乡的儿女也陆续回到老屋。琐碎的争吵、迟到的和解与一桌桌熟悉的饭菜，共同拼出普通人最真实的烟火人生。",
    featured: true,
    isHot: true,
  },
  {
    id: "4",
    title: "风起长林",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=epic%20ancient%20chinese%20costume%20drama%20poster%20art%2C%20misty%20mountain%20ranges%20with%20a%20banner%20and%20armored%20silhouette%2C%20ink%20wash%20texture%20in%20deep%20blue%20and%20gold%2C%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-04&orientation=portrait",
    genres: ["古装", "历史", "权谋"],
    region: "中国",
    year: 2025,
    rating: 8.6,
    director: "沈砚之",
    actors: ["顾长风", "慕容雪", "萧景桓"],
    duration: "全45集",
    releaseDate: "2025-06-18",
    summary: "边境风起，一场关于家国与信念的权谋大戏就此展开。",
    synopsis: "长林军因一场胜仗功高震主，年仅及冠的少将军顾长风被迫接过父辈的旗帜。朝堂暗流、边境烽火、旧友反目，他在步步惊心的博弈中守住心中那条底线。风起于青萍之末，长林之名终将被后世铭记。",
    featured: true,
    isHot: true,
  },
  {
    id: "5",
    title: "都市浮生",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=modern%20urban%20drama%20poster%20art%2C%20glass%20skyscrapers%20skyline%20at%20blue%20hour%20with%20warm%20window%20lights%2C%20sleek%20navy%20and%20orange%20color%20palette%2C%20cinematic%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-05&orientation=portrait",
    genres: ["都市", "爱情", "职场"],
    region: "中国",
    year: 2024,
    rating: 7.9,
    director: "林见一",
    actors: ["沈知微", "陆则安", "周嘉树"],
    duration: "全36集",
    releaseDate: "2024-03-12",
    summary: "五个年轻人在大都市打拼，笑与泪都写在这座不眠之城里。",
    synopsis: "合租在同一栋老楼里的五个年轻人，来自不同城市、怀揣不同野心。加班的深夜、合租的琐碎、突如其来的爱情与离别，让他们一次次重新认识自己。《都市浮生》用细腻的笔触描摹当代都市青年的真实群像。",
    isHot: true,
  },
  {
    id: "6",
    title: "暗巷追凶",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=neo-noir%20crime%20action%20poster%20art%2C%20narrow%20neon-lit%20alley%20with%20a%20running%20silhouette%2C%20teal%20and%20orange%20cinematic%20lighting%2C%20gritty%20atmosphere%2C%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-06&orientation=portrait",
    genres: ["动作", "犯罪"],
    region: "中国香港",
    year: 2025,
    rating: 8.1,
    director: "麦子豪",
    actors: ["高振东", "何静仪", "麦嘉俊"],
    duration: "110分钟",
    releaseDate: "2025-08-01",
    summary: "一条不足百米的老巷，藏着整座城市最危险的秘密。",
    synopsis: "卧底警员阿东在旧城区蛰伏三年，眼看任务即将收网，一次意外让身份濒临暴露。狭窄的暗巷成为他唯一的战场，他必须在黑帮的反扑与同僚的怀疑之间杀出一条生路。",
    featured: true,
  },
  {
    id: "7",
    title: "时光信笺",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=romantic%20drama%20poster%20art%2C%20vintage%20wooden%20desk%20with%20handwritten%20letters%20and%20dried%20flowers%20by%20a%20sunlit%20window%2C%20warm%20cream%20and%20muted%20navy%20tones%2C%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-07&orientation=portrait",
    genres: ["爱情", "剧情"],
    region: "中国",
    year: 2023,
    rating: 8.2,
    director: "温以晴",
    actors: ["阮清和", "顾言书", "许安然"],
    duration: "116分钟",
    releaseDate: "2023-05-20",
    summary: "一封迟到十年的信，让两个人重新走进彼此的时光。",
    synopsis: "整理祖母遗物时，女孩林晚发现一沓从未寄出的信。循着字迹，她找到了信中那个名字，也揭开一段被时代洪流冲散的旧日爱情。跨越十年的信笺，串起两代人对爱与告别的理解。",
    isHot: true,
  },
  {
    id: "8",
    title: "笑闹一家亲",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=bright%20family%20comedy%20poster%20art%2C%20cheerful%20cluttered%20living%20room%20with%20colorful%20furniture%20and%20warm%20afternoon%20light%2C%20playful%20orange%20and%20cream%20palette%2C%20flat%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-08&orientation=portrait",
    genres: ["喜剧", "家庭"],
    region: "中国",
    year: 2024,
    rating: 7.6,
    director: "钱多多",
    actors: ["马大伟", "周笑笑", "钱有才"],
    duration: "105分钟",
    releaseDate: "2024-10-01",
    summary: "一大家子挤在老房子里，鸡飞狗跳的日常笑到停不下来。",
    synopsis: "爷爷突发奇想要办一场“家庭春晚”，于是三代人各显神通，把平静的老屋搅得鸡飞狗跳。误会、乌龙与突如其来的温情轮番上演，笑过之后才发现，最珍贵的不过是一家人整整齐齐。",
  },
  {
    id: "9",
    title: "深海回响",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=sci-fi%20mystery%20poster%20art%2C%20deep%20ocean%20trench%20with%20bioluminescent%20creatures%20and%20a%20small%20submarine%20light%2C%20dark%20teal%20and%20electric%20blue%20tones%2C%20cinematic%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-09&orientation=portrait",
    genres: ["科幻", "悬疑", "惊悚"],
    region: "美国",
    year: 2025,
    rating: 8.4,
    director: "Ethan Cole",
    actors: ["David Marsh", "Nina Reyes", "Tom Hall"],
    duration: "全12集",
    releaseDate: "2025-04-25",
    summary: "深海研究站收到一段无法解释的信号，恐惧随之而来。",
    synopsis: "位于海沟底部的研究站突然与外界失联，救援小队潜入深海中，却发现站内一切如常，唯独少了一个人。随着他们越走越深，来自深渊的低频回响似乎正呼唤着每一个人。",
    isHot: true,
  },
  {
    id: "10",
    title: "沉默的证人",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=crime%20drama%20poster%20art%2C%20empty%20courtroom%20with%20a%20single%20chair%20under%20a%20cold%20beam%20of%20light%2C%20desaturated%20navy%20and%20grey%20tones%2C%20tense%20cinematic%20mood%2C%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-10&orientation=portrait",
    genres: ["悬疑", "剧情"],
    region: "韩国",
    year: 2024,
    rating: 8.0,
    director: "Kim Jae-hyun",
    actors: ["Lee Hana", "Park Junseo", "Choi Mira"],
    duration: "121分钟",
    releaseDate: "2024-07-19",
    summary: "唯一能作证的人选择了沉默，真相由谁来守护。",
    synopsis: "一桩看似简单的案件，却因为唯一的目击者始终保持沉默而陷入僵局。年轻检察官在追查真相的过程中，逐渐发现沉默背后藏着更深的恐惧与无奈。",
  },
  {
    id: "11",
    title: "大漠孤烟",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=desert%20adventure%20action%20poster%20art%2C%20endless%20sand%20dunes%20with%20a%20lone%20rider%20silhouette%20under%20a%20burning%20sunset%2C%20golden%20orange%20and%20deep%20navy%20tones%2C%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-11&orientation=portrait",
    genres: ["动作", "冒险", "剧情"],
    region: "中国",
    year: 2022,
    rating: 7.8,
    director: "铁木真",
    actors: ["燕孤城", "云娘", "老刀"],
    duration: "128分钟",
    releaseDate: "2022-08-12",
    summary: "大漠深处，一个独行者带着秘密与命运正面相遇。",
    synopsis: "退隐多年的游侠燕孤城为护送一箱遗物重返大漠，一路上仇家与旧友轮番出现。黄沙之下埋着的不只是财富，还有一段他不愿再提的往事。",
    isClassic: true,
  },
  {
    id: "12",
    title: "追梦赤子心",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=youth%20sports%20inspirational%20poster%20art%2C%20young%20athletes%20on%20a%20running%20track%20at%20golden%20hour%20with%20warm%20light%20rays%2C%20energetic%20orange%20and%20blue%20palette%2C%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-12&orientation=portrait",
    genres: ["青春", "励志", "运动"],
    region: "中国",
    year: 2023,
    rating: 8.1,
    director: "滕飞",
    actors: ["江野", "陆小满", "陈骁"],
    duration: "全32集",
    releaseDate: "2023-07-08",
    summary: "一群不被看好的少年，用汗水追逐一个几乎不可能的梦。",
    synopsis: "来自小镇的田径队因成绩垫底面临解散，新教练却执意要带他们冲击省赛。天赋平平的少年们只能在一次次跌倒中爬起来，用最笨拙的方式证明：梦想从来不论出身。",
    isClassic: true,
  },
  {
    id: "13",
    title: "极地营救",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=disaster%20rescue%20action%20poster%20art%2C%20frozen%20polar%20landscape%20with%20a%20lone%20helicopter%20and%20blizzard%2C%20icy%20blue%20and%20orange%20emergency%20light%20accents%2C%20cinematic%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-13&orientation=portrait",
    genres: ["灾难", "动作", "冒险"],
    region: "美国",
    year: 2025,
    rating: 8.0,
    director: "Marcus Lane",
    actors: ["Ryan Ford", "Emily Stone", "Chris Doyle"],
    duration: "134分钟",
    releaseDate: "2025-12-05",
    summary: "极夜降临前的最后六小时，一场与死亡赛跑的营救。",
    synopsis: "南极科考站在极端暴风雪中失去联系，一支六人救援队带着有限的燃料出发。零下六十度的荒原上，他们不仅要对抗自然，还要面对队伍内部逐渐失控的恐惧。",
    featured: true,
  },
  {
    id: "14",
    title: "巷子深处的秘密",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=small%20town%20mystery%20poster%20art%2C%20old%20stone%20alley%20with%20shuttered%20windows%20and%20a%20faint%20light%2C%20muted%20blue%20grey%20and%20dim%20amber%20tones%2C%20suspenseful%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-14&orientation=portrait",
    genres: ["悬疑", "剧情"],
    region: "中国",
    year: 2024,
    rating: 7.7,
    director: "吴一舟",
    actors: ["方静", "郑开", "许老太"],
    duration: "全24集",
    releaseDate: "2024-05-16",
    summary: "平静的老巷子里，每个人都藏着一个不愿说的秘密。",
    synopsis: "搬进老巷的年轻记者发现，邻居们对十年前的一桩失踪案讳莫如深。她开始逐一走访，每推开一扇门，真相就离她更近一步，也更危险一分。",
  },
  {
    id: "15",
    title: "午夜列车",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=horror%20thriller%20poster%20art%2C%20empty%20night%20train%20carriage%20with%20flickering%20lights%20and%20lone%20passenger%2C%20cold%20navy%20and%20blood%20orange%20accents%2C%20eerie%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-15&orientation=portrait",
    genres: ["惊悚", "恐怖", "悬疑"],
    region: "日本",
    year: 2023,
    rating: 7.5,
    director: "Hiroshi Tanaka",
    actors: ["Yuki Sato", "Ken Watanabe", "Aoi Mori"],
    duration: "98分钟",
    releaseDate: "2023-10-31",
    summary: "一列没有终点站的夜车，乘客一个接一个消失。",
    synopsis: "加班到深夜的上班族搭上了末班车，却发现车厢里所有人都记不清自己为何上车。列车驶过一站又一站，始终没有停靠的迹象，恐惧在封闭的空间里悄然蔓延。",
  },
  {
    id: "16",
    title: "山河故人录",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=historical%20epic%20poster%20art%2C%20ancient%20chinese%20scroll%20painting%20style%20river%20and%20mountains%20with%20tiny%20travelers%2C%20sepia%20and%20deep%20indigo%20ink%20tones%2C%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-16&orientation=portrait",
    genres: ["历史", "剧情", "传记"],
    region: "中国",
    year: 2022,
    rating: 8.5,
    director: "程守一",
    actors: ["司马迁远", "柳青", "韩愈"],
    duration: "全40集",
    releaseDate: "2022-04-09",
    summary: "乱世之中，一群读书人用笔墨记录下一段山河的记忆。",
    synopsis: "朝代更迭、家国动荡，几位文人以修史为己任，在颠沛流离中守护着即将被遗忘的真相。《山河故人录》以史笔为镜，照见个人命运与时代洪流的碰撞。",
    isClassic: true,
  },
  {
    id: "17",
    title: "爱情呼叫转移",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=romantic%20comedy%20poster%20art%2C%20couple%20sharing%20umbrella%20on%20a%20rainy%20city%20street%20at%20dusk%2C%20warm%20orange%20and%20soft%20blue%20tones%2C%20playful%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-17&orientation=portrait",
    genres: ["爱情", "喜剧"],
    region: "中国",
    year: 2024,
    rating: 7.4,
    director: "唐悠然",
    actors: ["夏之遥", "顾西洲", "白白"],
    duration: "102分钟",
    releaseDate: "2024-02-14",
    summary: "一个打错的电话，让两条平行的人生轨迹意外交汇。",
    synopsis: "屡屡相亲失败的都市青年意外拨错了一通电话，从此和电话那头的陌生人开始了持续的深夜聊天。在一次次误会与巧合里，他们慢慢发现，缘分也许早有安排。",
  },
  {
    id: "18",
    title: "铁血黎明",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=war%20epic%20poster%20art%2C%20soldiers%20marching%20through%20a%20smoking%20field%20at%20dawn%20with%20a%20lowering%20flag%2C%20desaturated%20blue%20grey%20and%20orange%20sky%2C%20somber%20cinematic%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-18&orientation=portrait",
    genres: ["战争", "历史", "剧情"],
    region: "中国",
    year: 2021,
    rating: 8.6,
    director: "石铁军",
    actors: ["赵振国", "孙卫东", "林秀英"],
    duration: "146分钟",
    releaseDate: "2021-09-03",
    summary: "黎明前的黑夜最漫长，总有人愿意成为第一束光。",
    synopsis: "一场决定命运的关键战役前夜，一支侦察小队深入敌后执行几乎不可能完成的任务。个人的恐惧、战友的信任与家国的重量，在黎明到来之前交织成为最悲壮的抉择。",
    isClassic: true,
  },
  {
    id: "19",
    title: "银河漫游者",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=space%20odyssey%20poster%20art%2C%20spaceship%20sailing%20past%20a%20giant%20ringed%20planet%20with%20a%20distant%20orange%20sun%2C%20deep%20indigo%20and%20amber%20tones%2C%20epic%20cinematic%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-19&orientation=portrait",
    genres: ["科幻", "冒险"],
    region: "美国",
    year: 2020,
    rating: 8.8,
    director: "Alan Whitmore",
    actors: ["John Reed", "Sophia Lane", "Mark Yu"],
    duration: "138分钟",
    releaseDate: "2020-06-20",
    summary: "一次寻找人类新家园的漫游，跨越整整一个星系。",
    synopsis: "为了给濒临枯竭的母星寻找出路，一艘载着最后希望的飞船驶向未知的星系。漫长的航行中，船员们要面对时间的残酷、彼此的猜忌，以及一个足以颠覆一切的发现。",
    isClassic: true,
  },
  {
    id: "20",
    title: "旧时光的我们",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=nostalgic%20coming%20of%20age%20poster%20art%2C%201990s%20schoolyard%20with%20bicycles%20and%20afternoon%20sunlight%20through%20leaves%2C%20warm%20sepia%20and%20faded%20blue%20tones%2C%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-20&orientation=portrait",
    genres: ["剧情", "青春", "家庭"],
    region: "中国",
    year: 2019,
    rating: 8.4,
    director: "陈拾光",
    actors: ["胡同里的孩子", "周晓", "林安"],
    duration: "全28集",
    releaseDate: "2019-11-11",
    summary: "九十年代的旧街坊里，藏着我们再也回不去的夏天。",
    synopsis: "小板凳、老冰棍和傍晚的蝉鸣，构成了一代人的少年记忆。剧集以几个孩子的成长为主线，讲述那个慢节奏年代里，邻里之间最朴素也最动人的情谊。",
    isClassic: true,
  },
  {
    id: "21",
    title: "寂静山丘",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=psychological%20horror%20poster%20art%2C%20lonely%20foggy%20hillside%20house%20with%20a%20single%20lit%20window%2C%20cold%20desaturated%20blue%20and%20faint%20orange%20glow%2C%20unsettling%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-21&orientation=portrait",
    genres: ["恐怖", "悬疑", "惊悚"],
    region: "美国",
    year: 2024,
    rating: 7.3,
    director: "Greg Holloway",
    actors: ["Anna Bell", "Peter Nash", "Diana Frost"],
    duration: "101分钟",
    releaseDate: "2024-10-25",
    summary: "搬进山间老宅的一家四口，很快发现寂静比声音更可怕。",
    synopsis: "为了逃离城市生活，一家人搬进了远离人烟的山间老宅。起初的宁静令人安心，但每到深夜，空无一人的走廊里总会响起无法解释的动静，而墙壁后似乎一直有人在等待。",
  },
  {
    id: "22",
    title: "医者仁心",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=medical%20drama%20poster%20art%2C%20bright%20modern%20hospital%20corridor%20with%20medical%20staff%20silhouettes%2C%20clean%20white%20and%20navy%20with%20warm%20orange%20accents%2C%20hopeful%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-22&orientation=portrait",
    genres: ["医疗", "剧情", "都市"],
    region: "中国",
    year: 2025,
    rating: 8.2,
    director: "夏明远",
    actors: ["顾仁心", "白大夫", "林护士长"],
    duration: "全38集",
    releaseDate: "2025-03-08",
    summary: "急诊室的每一夜，都是与生命的一次郑重对话。",
    synopsis: "年轻医生顾仁心进入市医院急诊科，面对的不只是复杂的病情，还有人性与制度的双重考验。在一位位病人的故事里，他逐渐读懂了“医者仁心”四个字真正的分量。",
    isHot: true,
  },
  {
    id: "23",
    title: "江湖再会",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=wuxia%20martial%20arts%20poster%20art%2C%20bamboo%20forest%20with%20two%20swordsmen%20facing%20each%20other%20in%20mist%2C%20ink%20green%20and%20deep%20navy%20with%20orange%20accent%2C%20elegant%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-23&orientation=portrait",
    genres: ["武侠", "动作", "剧情"],
    region: "中国",
    year: 2023,
    rating: 8.0,
    director: "古三叠",
    actors: ["叶惊鸿", "苏莫问", "白衣客"],
    duration: "119分钟",
    releaseDate: "2023-12-22",
    summary: "两位故人十年后再会江湖，恩怨与情义只在一剑之间。",
    synopsis: "退隐的剑客叶惊鸿本想就此了却前尘，却被一封旧友的挑战书重新卷入江湖。竹林深处的这场对决，赌的不是胜负，而是两人十年间各自背负的选择与遗憾。",
    isHot: true,
  },
  {
    id: "24",
    title: "春天来了",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=gentle%20family%20drama%20poster%20art%2C%20cherry%20blossom%20tree%20over%20a%20quiet%20village%20road%20with%20soft%20petals%20falling%2C%20pastel%20pink%20cream%20and%20soft%20blue%20tones%2C%20tender%20painterly%20illustration%2C%20no%20text&width=400&height=600&seq=film-poster-24&orientation=portrait",
    genres: ["剧情", "家庭"],
    region: "韩国",
    year: 2022,
    rating: 8.3,
    director: "Seo Eun-jung",
    actors: ["Yoon Sora", "Kim Doyoon", "Bae Hyeri"],
    duration: "112分钟",
    releaseDate: "2022-03-18",
    summary: "冬天走远之后，这个家终于等来了迟到很久的春天。",
    synopsis: "母亲离世后，性格迥异的三兄妹被迫回到老家共同生活。从最初的争吵与疏离，到逐渐学着理解彼此的沉默，他们在又一个春天到来的时刻，重新学会了如何去爱。",
    isClassic: true,
  },
];